const $ = jQuery.noConflict();
import 'slick-carousel';

const sliders = document.querySelectorAll('.component-slider');

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (sliders.length) {
			sliders.forEach((slider) => {
				if (!slider.hasAttribute('data-slick')) {
					const parentWithSettings = slider.closest('[data-slick]');

					if (parentWithSettings) {
						slider.setAttribute(
							'data-slick',
							parentWithSettings.getAttribute('data-slick')
						);
					}
				}
			});

			$('.component-slider').slick();

			$(window).on('block-library-change', function () {
				$('.component-slider').slick('refresh');
			});
		}

		// counter for accommodations
		const accomSlider = $('.trip-accommodations__slider');
		// if (slider.classList.contains('trip-accommodations__slider')) {
		if (accomSlider) {
			const slideStatus = accomSlider
				.parent('.trip-accommodations__slider-wrap')
				.children('.trip-accommodations__slide-count');
			accomSlider.on(
				'init reInit afterChange',
				function (event, slick, currentSlide) {
					//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
					const i = (currentSlide ? currentSlide : 0) + 1;
					slideStatus.text(i + '/' + slick.slideCount);
				}
			);
		}

		const tripLeaderSlider = $('.progress-slider');

		if (tripLeaderSlider) {
			tripLeaderSlider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 1)) * 100;

					const tripLeaderProgress = $(event.target)
						.closest('.container')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					const tripLeaderProgressSecondary = $(event.target)
						.closest('section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					tripLeaderProgress
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);

					tripLeaderProgressSecondary
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}

		const searchResultsTripSlider = $('.search-results__trip-slider');

		if (searchResultsTripSlider) {
			searchResultsTripSlider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 4)) * 100;

					const tripProgress = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					const tripProgressSecondary = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					tripProgress
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);

					tripProgressSecondary
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}

		const searchResultsPageDestinationSlider = $(
			'.search-results__page-destination-slider'
		);

		if (searchResultsPageDestinationSlider) {
			searchResultsPageDestinationSlider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 4)) * 100;

					const tripProgress = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					const tripProgressSecondary = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					tripProgress
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);

					tripProgressSecondary
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}

		const searchResultsPageNoDestinationSlider = $(
			'.search-results__page-no-destination-slider'
		);

		if (searchResultsPageNoDestinationSlider) {
			searchResultsPageNoDestinationSlider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 4)) * 100;

					const tripProgress = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					const tripProgressSecondary = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					tripProgress
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);

					tripProgressSecondary
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}

		const searchResultsGuideSlider = $('.search-results__guide-slider');

		if (searchResultsGuideSlider) {
			searchResultsGuideSlider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 4)) * 100;

					const tripProgress = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					const tripProgressSecondary = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					tripProgress
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);

					tripProgressSecondary
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}

		const searchResultsPostSlider = $('.search-results__post-slider');

		if (searchResultsPostSlider) {
			searchResultsPostSlider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 4)) * 100;

					const tripProgress = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					const tripProgressSecondary = $(event.target)
						.closest('.search-results__section')
						.children('.progress-slider-bar')
						.children('.progress-bar');

					tripProgress
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);

					tripProgressSecondary
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}

		const awardsSlider = $(
			'.block-award-banner .wp-block-columns-wrapper > div'
		);

		if (awardsSlider) {
			awardsSlider.slick({
				infinite: true,
				arrows: false,
				dots: true,
				centerMode: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 996,
						settings: 'unslick',
					},
				],
			});
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
